import Accordions4i from "../../common/accordions25.js";
import { initProductScroller } from "../common/modules/productscroller.js";
let accordions;

function init(){
    if(document.getElementById('dotd-slider')) initProductScroller();
    initAccordions();
}

function initAccordions() {
    const mainContent = document.getElementById("mainContent");
    accordions = new Accordions4i();
    accordions.init(mainContent);

    adjustAccordions();
    window.addEventListener("resize", adjustAccordions);
}

function adjustAccordions() {
    const prodDetailsAccordion = document.getElementById("detailsSection");
    const prodDetailsOpen = prodDetailsAccordion.classList.contains("open");
    if (!prodDetailsOpen && window.innerWidth >= 600) accordions.open(prodDetailsAccordion);
    else if (prodDetailsOpen && window.innerWidth < 600) accordions.close(prodDetailsAccordion);
}

init();